import React from "react";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import PropTypes from "prop-types";
import {
    Box,
    Divider,
    ListItem,
    ListItemButton,
    ListItemText,
    Typography,
} from "@mui/material";
import { convertToProperText, getCustomDateFormat } from "@crema/utility/Utils";
import { useDispatch } from "react-redux";
import { readNotifications } from "redux/actions/Home";
import { useNavigate } from "react-router-dom";
const NotificationItem = (props) => {
    const navigate = useNavigate();
    const { item, onClose } = props;
    const dispatch = useDispatch();
    const readMessage = (item) => {
        let url = "";
        if (item.type == "ISSUE") {
            if (item.isRead !== "Y") {
                dispatch(readNotifications(item.id));
            }
            url = `issue/detail/${item.urlId}`;
            navigate(url);
        }
        if (item.type == "CRM_FUND") {
            if (item.isRead !== "Y") {
                dispatch(readNotifications(item.id));
            }
            url = `client-details/${item.memType}/${item.urlId}`;
            navigate(url);
        }
        if (item.type == "ROOM_BOOKING") {
            if (item.isRead !== "Y") {
                dispatch(readNotifications(item.id));
            }
            url = `/room/booking-detail/${item.urlId}`;
            navigate(url);
        }
        if (item.type == "BIRTHDAY_WISHES") {
            if (item.isRead !== "Y") {
                dispatch(readNotifications(item.id));
            }
            url = `/dashboard`;
            navigate(url);
        }

        onClose(false);
    };
    return (
        <>
            <ListItem
                sx={{
                    p: 0,
                }}
                className="item-hover"
            >
                <ListItemButton
                    selected={item.isRead !== "Y"}
                    onClick={() => readMessage(item)}
                    sx={{
                        py: 2,
                        px: 4,
                    }}
                >
                    <ListItemAvatar
                        sx={{
                            minWidth: 0,
                            mr: 4,
                        }}
                    >
                        <Avatar
                            sx={{
                                width: 48,
                                height: 48,
                            }}
                            alt="avatar"
                            src={`/assets/images/dashboard/avatar.svg`}
                        />
                    </ListItemAvatar>
                    <ListItemText
                        primary={
                            <Typography
                                variant="body1"
                                color="text.primary"
                                sx={{
                                    lineHeight: 1.2,
                                    fontWeight: 600,
                                }}
                            >
                                {convertToProperText(item.type)}
                            </Typography>
                        }
                        secondary={
                            <>
                                <Typography>
                                    <Box
                                        variant="body2"
                                        color="text.primary"
                                        sx={{
                                            lineHeight: 1.2,
                                            fontWeight: 600,
                                        }}
                                    >
                                        {convertToProperText(item.msg)}
                                    </Box>
                                    {getCustomDateFormat(
                                        item.createdOn,
                                        "DD MMM YYYY"
                                    )}
                                </Typography>
                            </>
                        }
                    />
                </ListItemButton>
            </ListItem>
            <Divider />
        </>
    );
};

export default NotificationItem;

NotificationItem.propTypes = {
    item: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
};
